/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkip2ForwardIcon24Solid = forwardRef('MediaUiASkip2ForwardIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M22.5 4A1.5 1.5 0 0 0 21 5.5v4.74l-8.322-5.855C11.552 3.592 10 4.398 10 5.775v3.762L2.678 4.385C1.552 3.592 0 4.398 0 5.775v12.45c0 1.377 1.552 2.183 2.678 1.39L10 14.463v3.762c0 1.377 1.552 2.183 2.678 1.39L21 13.76V18.5a1.5 1.5 0 0 0 3 0v-13A1.5 1.5 0 0 0 22.5 4Z" })));
});
